import { render, staticRenderFns } from "./RateLimitNotification.vue?vue&type=template&id=255fb182&scoped=true"
import script from "./RateLimitNotification.vue?vue&type=script&lang=js"
export * from "./RateLimitNotification.vue?vue&type=script&lang=js"
import style0 from "./RateLimitNotification.vue?vue&type=style&index=0&id=255fb182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255fb182",
  null
  
)

export default component.exports